// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'gear-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m16.523 10.71-.749-.684c-.068 0-.068-.069-.068-.069-.544-.547-.476-1.436.068-1.983l.75-.683c.34-.274.476-.684.476-1.094-.068-.753-.68-1.368-1.43-1.3l-1.021.069h-.136c-.75-.069-1.362-.684-1.294-1.436l.068-1.026c0-.41-.136-.82-.476-1.094-.613-.547-1.43-.547-1.975.069l-.68.752c0 .068-.069.068-.137.137-.545.41-1.43.41-1.906-.206l-.681-.752C7.06 1.137 6.652 1 6.242 1c-.748.068-1.361.684-1.293 1.436l.068 1.026v.136c-.068.752-.68 1.368-1.43 1.3h-1.09c-.408 0-.816.136-1.088.478-.477.547-.477 1.368.136 1.915l.749.683c.068 0 .068.069.068.069.476.615.476 1.504-.136 1.983l-.75.683c-.34.274-.476.684-.476 1.094.068.753.68 1.368 1.43 1.3l1.021-.069h.136c.75.069 1.362.684 1.294 1.436l-.068 1.026c0 .41.136.82.476 1.094.545.547 1.43.478 1.975-.069l.68-.752c0-.068.069-.068.069-.068.544-.547 1.43-.479 1.974.068l.681.752c.272.274.68.479 1.09.479.748-.068 1.361-.684 1.293-1.436l-.068-1.025v-.137c.068-.752.68-1.368 1.43-1.3l1.021.069c.409 0 .817-.137 1.09-.479.612-.615.612-1.436 0-1.983zm-7.489 1.504c-1.77 0-3.2-1.436-3.2-3.214a3.203 3.203 0 0 1 3.2-3.214c1.77 0 3.2 1.436 3.2 3.214a3.203 3.203 0 0 1-3.2 3.214z'
  />
);

export const viewBox = '0 0 18 18';
